import { UI_FooterCard, FooterCardProps } from 'ui/components/2-molecules/Card/FooterCard/FooterCard';
import styles from './FooterCardList.module.scss';

interface FooterCardListProps {
	cards: FooterCardProps[];
}

export const UI_FooterCardList = ({ cards }: FooterCardListProps) => (
	<div className={styles.FooterCardList}>
		{cards.map((card, index) => (
			<UI_FooterCard key={index} {...card} />
		))}
	</div>
);
